<template>
    <v-card elevation="0">
        <v-card-title primary-title class="pb-1">
            <div
                v-if="$vuetify.breakpoint.xs"
                class="grey--text text-overline ml-2"
            >
                Atenciones
            </div>
            <div
                v-else
                class="
                    font-weight-light
                    grey--text
                    text-h4
                    ml-2
                    text-capitalize
                "
            >
                Atenciones
            </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table
                :loading="isLoadingSingleView"
                :footer-props="footersProps"
                :page.sync="page"
                :headers="headers"
                :items="currentComercialAttentions"
                :server-items-length="attentionsTableItemCount"
            >
                <template v-slot:item.fecha_contacto="{ item }">
                    {{
                        item.fecha_contacto
                            ? formatDate(item.fecha_contacto)
                            : ''
                    }}
                </template>
                <template v-slot:item.updated_on="{ item }">
                    {{ item.updated_on ? formatDate(item.updated_on) : '' }}
                </template>
                <template v-slot:item.ver="{ item }">
                    <div class="d-flex justify-center flex-row">
                        <v-tooltip v-if="isOferta(item.content_type)" left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-badge
                                    v-if="
                                        !isFechaContactoEqualToUpdatedOn(item)
                                    "
                                    icon="mdi-update"
                                    overlap
                                    color="red"
                                    bordered
                                >
                                    <v-btn
                                        v-if="!$vuetify.breakpoint.smAndDown"
                                        :x-small="!$vuetify.breakpoint.smAndDown"
                                        elevation="3"
                                        :color="getColor(item)"
                                        outlined
                                        width="120"
                                        height="35"
                                        @click="showService(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon>
                                            {{ getIcon(item.content_type) }}
                                        </v-icon>
                                        {{ getText(item) }}
                                    </v-btn>
                                    <v-btn
                                        :x-small="!$vuetify.breakpoint.smAndDown"
                                        v-else
                                        :color="getColor(item)"
                                        outlined
                                        @click="showService(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="mr-md-2">
                                            {{ getIcon(item.content_type) }}
                                        </v-icon>
                                    </v-btn>
                                </v-badge>
                                <v-btn
                                    v-if="
                                        !$vuetify.breakpoint.smAndDown &&
                                        isFechaContactoEqualToUpdatedOn(item)
                                    "
                                    :color="getColor(item)"
                                    outlined
                                    :x-small="!$vuetify.breakpoint.smAndDown"
                                    width="120"
                                    height="35"
                                    @click="showService(item)"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon class="mr-md-2">
                                        {{ getIcon(item.content_type) }}
                                    </v-icon>
                                    {{ getText(item) }}
                                </v-btn>
                                <v-btn
                                    v-if="
                                        $vuetify.breakpoint.smAndDown &&
                                        isFechaContactoEqualToUpdatedOn(item)
                                    "
                                    :x-small="!$vuetify.breakpoint.smAndDown"
                                    :color="getColor(item)"
                                    outlined
                                    @click="showService(item)"
                                >
                                    <v-icon class="mr-md-2">
                                        {{ getIcon(item.content_type) }}
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span class="text-center"
                                ><div>
                                    {{ item.servicio.estado }}
                                </div>
                                <div
                                    v-if="
                                        !isFechaContactoEqualToUpdatedOn(item)
                                    "
                                >
                                    {{ formatDate(item.updated_on) }}
                                </div>
                            </span>
                        </v-tooltip>
                        <v-btn
                            v-if="
                                !$vuetify.breakpoint.smAndDown &&
                                !isOferta(item.content_type)
                            "
                            :color="getColor(item)"
                            :x-small="!$vuetify.breakpoint.smAndDown"
                            outlined
                            width="120"
                            height="35"
                            @click="showService(item)"
                        >
                            <v-icon>
                                {{ getIcon(item.content_type) }}
                            </v-icon>

                            {{ getText(item) }}
                        </v-btn>
                        <v-btn
                            v-if="
                                $vuetify.breakpoint.smAndDown &&
                                !isOferta(item.content_type)
                            "
                            :x-small="!$vuetify.breakpoint.smAndDown"
                            :color="getColor(item)"
                            outlined
                            @click="showService(item)"
                        >
                            <v-icon class="mr-md-2">
                                {{ getIcon(item.content_type) }}
                            </v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>

        <PDFView :offer="offer" />
        <AdministrationForm />
        <ScheduleForm />
        <NoInterestForm />
    </v-card>
</template>
<script>
import { mapState } from 'vuex';
import PDFView from '@/components/PDFView/PDFView.vue';
import AdministrationForm from '@/components/ComercialTeletrabajo/TtForm/AdministrationForm.vue';
import ScheduleForm from '@/components/ComercialTeletrabajo/TtForm/ScheduleForm.vue';
import NoInterestForm from '@/components/ComercialTeletrabajo/TtForm/NoInterestForm';
import { objectSnakeToCamelCase } from '@/util/libUtil.js';

export default {
    name: 'ComercialesTableAttentionsTable',
    components: {
        PDFView,
        AdministrationForm,
        ScheduleForm,
        NoInterestForm,
    },
    props: {
        filterParams: null,
    },
    data: () => ({
        page: 1,
        footersProps: {
            disableItemsPerPage: false,
            itemsPerPageOptions: [10],
        },
        offer: null,
        headers: [
            {
                text: 'Nombre',
                align: 'start',
                value: 'cliente.nombre',
            },
            {
                text: 'Identificación',
                value: 'cliente.documento',
            },
            {
                text: 'Telf',
                value: 'cliente.telefonos_contacto[0]',
            },
            {
                text: 'Fecha contacto',
                value: 'fecha_contacto',
            },
            {
                text: 'Actualizado',
                value: 'updated_on',
            },
            {
                text: 'Comercial',
                value: 'comercial.nombre',
            },
            {
                text: 'Operador',
                value: 'cliente.isp_actual',
            },
            {
                text: 'Segmento',
                value: 'cliente.segmento',
            },
            {
                text: 'Visualizar',
                value: 'ver',
                align: 'center',
                sortable: false,
            },
        ],
    }),
    computed: {
        currentComercialAttentions: {
            get() {
                return this.$store.state.gerencia.currentComercialAttentions;
            },
            set(value) {
                this.$store.commit(
                    'gerencia/currentComercialAttentions',
                    value
                );
            },
        },
        ...mapState('gerencia', {
            attentionsTableItemCount: (state) => state.attentionsTableItemCount,
            // currentComercialAttentions: (state) =>
            //     state.currentComercialAttentions,
            currentComercial: (state) => state.currentComercial,
            dateFilter: (state) => state.dateFilter,
            isLoadingSingleView: (state) => state.isLoadingSingleView,
        }),
    },
    methods: {
        formatDate(date) {
            if (!date) {
                return '';
            }
            let mondate = new Date(date);
            return `${mondate.getDate()}/${
                mondate.getMonth() + 1
            }/${mondate.getFullYear()}`;
        },
        getColor(item) {
            let type = item.content_type;
            return type == null
                ? 'green accent-3'
                : type.includes('oferta')
                ? 'success'
                : type.includes('agendado')
                ? 'pink'
                : type.includes('no interesado')
                ? item.servicio.tipo === 'NC'
                    ? 'error'
                    : 'warning'
                : 'purple';
        },
        getText(item) {
            let type = item.content_type;
            return type == null
                ? 'Creado'
                : type.includes('oferta')
                ? 'Oferta'
                : type.includes('agendado')
                ? 'Agendado'
                : type.includes('no interesado')
                ? item.servicio.tipo === 'NC'
                    ? 'No contesta'
                    : 'No interesado'
                : 'Gestión';
        },
        isOferta(type) {
            return type && type.includes('oferta');
        },
        getIcon(type) {
            return type == null
                ? 'mdi-account-plus-outline'
                : type.includes('oferta')
                ? 'mdi-plus-box'
                : type.includes('agendado')
                ? 'mdi-calendar-arrow-right'
                : type.includes('no interesado')
                ? 'mdi-phone-hangup'
                : 'mdi-offer';
        },
        isFechaContactoEqualToUpdatedOn({ fecha_contacto, updated_on }) {
            return fecha_contacto.split('.')[0] === updated_on.split('.')[0];
        },
        showService(atencion) {
            atencion.comercial = objectSnakeToCamelCase(atencion.comercial);

            if (atencion.content_type == null) {
                return;
            } else if (atencion.content_type.includes('oferta')) {
                this.offer = JSON.parse(JSON.stringify(atencion.servicio));

                let PDFView = {
                    isLoadingHtmlOffer: true,
                    isOpenViewDialog: true,
                    ofertaHtml: '',
                };
                this.$store.commit('util/PDFView', PDFView);
            } else if (atencion.content_type.includes('agendado')) {
                atencion = objectSnakeToCamelCase(atencion);
                let ScheduleForm = {
                    isOpen: true,
                    isSaving: false,
                    isEditable: false,
                    form: { ...atencion, agendado: atencion.servicio },
                };
                this.$store.commit('teletrabajo/ScheduleForm', ScheduleForm);
            } else if (atencion.content_type.includes('gestion')) {
                let AdministrationForm = {
                    isOpen: true,
                    isSaving: false,
                    isEditable: false,
                    form: { ...atencion, gestion: atencion.servicio },
                };
                this.$store.commit(
                    'teletrabajo/AdministrationForm',
                    AdministrationForm
                );
            } else if (atencion.content_type.includes('no interesado')) {
                let NoInterestForm = {
                    isOpen: true,
                    isSaving: false,
                    isEditable: false,
                    form: { ...atencion, no_interesado: atencion.servicio },
                };
                this.$store.commit(
                    'teletrabajo/NoInterestForm',
                    NoInterestForm
                );
            }
        },
        isOfertaAntigua(oferta) {
            return (
                !oferta.paquetes.length ||
                oferta.paquetes.some(
                    ({ unidadVentaDeprecated }) => unidadVentaDeprecated != null
                )
            );
        },
    },
    watch: {
        filterParams() {
            let pageParams = {
                itemsPerPage: 10,
                page: this.page,
            };
            if (this.filterParams != null)
                this.$store.dispatch('gerencia/fetchAtenciones', {
                    ...pageParams,
                    ...this.filterParams,
                });
            else {
                this.currentComercialAttentions = [];
                this.page = 1;
            }
        },
        currentComercial() {
            this.page = 1;
        },
        page() {
            if (!this.filterParams) {
                let params = {
                    comercial: this.currentComercial?.id,
                    updated_on: this.dateFilter,
                    itemsPerPage: 10,
                    page: this.page,
                };

                this.$store.dispatch('gerencia/fetchAtenciones', params);
            } else {
                let pageParams = {
                    itemsPerPage: 10,
                    page: this.page,
                };
                this.$store.dispatch('gerencia/fetchAtenciones', {
                    ...pageParams,
                    ...this.filterParams,
                });
            }
        },
    },
};
</script>
